import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function SpringPilau() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Spring Pilau</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        350g basmati rice <br></br>
        600ml vegan vegetable stock<br></br>3 tbsp olive oil<br></br>2 red
        onions<br></br>4 cloves of garlic<br></br>2 green finger chillies
        <br></br>1 medium fennel bulb<br></br>
        250g asparagus<br></br>
        200g (frozen) mixed peas and broad beans<br></br>
        1.5 tsp ground cumin<br></br>
        1.5 tsp garam masala<br></br>
        3/4 tsp salt<br></br>
        Handful fresh mint<br></br>
        Handful fresh dill<br></br>1 lemon<br></br>
        <br></br>
      </Typography>

      <Typography>
        Wash the rice in a few changes of cold water until it runs clear, then
        leave to soak in cold water for 20 minutes. <br></br>
        Drain the rice, put into a large lidded saucepan and pour over the
        stock. <br></br>
        Bring to the boil, then cover the pan, turn the heat down to a whisper
        and leave to cook for 10 to 12 minutes.<br></br>
        Take off the heat and leave the rice, still covered, to steam through
        until needed.<br></br>
        <br></br>
        Meanwhile, heat the oil in a large, lidded pan on a medium flame.
        <br></br>
        Once hot, add the onions and cook for 6 to 8 minutes, until translucent
        and softening but not yet coloured.<br></br>
        Add the garlic and chillies, cook for another 2 minutes, then stir in
        the fennel and a couple of tablespoons of water, and ccover the pan.
        <br></br>
        Leave to cook for 8 minutes, until soft, then add the asparagus, peas,
        broad beans, cumin, garam masala, and salt.<br></br>
        Stir, c over again, cook for 3 to 5 minutes more, then take off the
        heat.<br></br>
        <br></br>
        Finely chop the herbs and fold them and the rice into the vegetable
        mixture - you might need to break up any clumps of rice delicately with
        your hands - then transfer to a serving dish and serve with wedges of
        lemon on the side.
      </Typography>
    </Card>
  );
}
